export default {

	init(element = document) {
		if (element.dataset.smsCharCounterInitialized) return;
		element.dataset.smsCharCounterInitialized = "1";

		const smsTextLength = document.createElement('div');
		smsTextLength.id = 'smsTextLength';
		smsTextLength.style.paddingInline = '0.75rem';

		element.parentNode.insertBefore(smsTextLength, element.nextSibling);

		document.getElementById('removeDiacritics')?.addEventListener('change', () => textLength(element));

		textLength(element);

		element.addEventListener('input', () => {
			textLength(element);
		});
	}
};

function textLength(smsTextEl) {
	const smsText = smsTextEl.value;

	const removeDiacriticsCheckbox = document.getElementById('removeDiacritics');
	let withDiacritics = true;
	if (removeDiacriticsCheckbox) {
		withDiacritics = !removeDiacriticsCheckbox.checked;
	}

	// Nastavení délky podle kódování
	const singleSmsLimit = withDiacritics ? 70 : 160;
	const multiSmsLimit = withDiacritics ? 67 : 153;

	// Výpočet zbývajících znaků a počtu SMS
	const textLength = smsText.length;
	const smsCount = textLength <= singleSmsLimit
		? 1
		: Math.ceil(textLength / multiSmsLimit);
	const maxCharsInCurrentSms = smsCount === 1 ? singleSmsLimit : smsCount * multiSmsLimit;
	const charsRemaining = maxCharsInCurrentSms - textLength;

	smsTextEl.maxLength = (5 * multiSmsLimit);

	function getKoncovka(charsRemaining) {
		// Výběr správné koncovky
		let koncovka;
		if (charsRemaining === 1) {
			return "";
		} else if (charsRemaining > 1 && charsRemaining < 5) {
			return "y";
		} else {
			return "ů";
		}
	}

	// Zobrazení výsledků
	document.getElementById('smsTextLength').innerHTML = 'Do konce aktuální zprávy zbývá: <strong>' + charsRemaining + ' znak' + getKoncovka(charsRemaining) + '</strong><br>Celkem zbývá: <strong>' + (smsTextEl.maxLength - textLength) + ' znak' + getKoncovka(smsTextEl.maxLength - textLength) + '</strong><br>Počet SMS:  <strong>' + smsCount + '</strong><br>';
}
